import { Center, Image, Modal, Paper } from '@mantine/core';
import { IconPlayerPlay } from '@tabler/icons-react';
import { useState } from 'react';

type ThumbnailPreviewProps = {
    url: string;
    isVideo?: boolean;
    alt: string;
    size?: number;
};

export const ThumbnailPreview = ({ url, isVideo = false, alt, size = 40 }: ThumbnailPreviewProps) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    return (
        <>
            <Paper
                onClick={() => setModalIsOpen(true)}
                pos="relative"
                w={size}
                h={size}
                withBorder
                radius="xs"
                style={{ cursor: 'pointer', overflow: 'hidden' }}
            >
                {isVideo ? (
                    <video
                        src={url}
                        muted
                        preload="metadata"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    />
                ) : (
                    <Image src={url} alt={alt} w="100%" h="100%" fit="cover" />
                )}
                {isVideo && (
                    <Center pos="absolute" style={{ inset: 0, pointerEvents: 'none' }}>
                        <IconPlayerPlay
                            size={16}
                            color="white"
                            style={{ filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))' }}
                        />
                    </Center>
                )}
            </Paper>

            <Modal
                opened={modalIsOpen}
                onClose={() => setModalIsOpen(false)}
                size="xl"
                title="Creative Preview"
                styles={{
                    content: { maxHeight: '90vh' },
                }}
            >
                <Center w="100%" mah="70vh">
                    {isVideo ? (
                        <video
                            src={url}
                            controls
                            autoPlay
                            loop
                            muted
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    ) : (
                        <Image src={url} alt={alt} fit="contain" maw="100%" mah="100%" />
                    )}
                </Center>
            </Modal>
        </>
    );
};
